import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "stage-logic"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "stage-logic__section-title-text" }
const _hoisted_4 = {
  key: 0,
  class: "stage-logic__section-body"
}
const _hoisted_5 = {
  key: 1,
  class: "stage-logic__section-empty"
}

import {
	computed,
	reactive,
	ref
} from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import { ProjectApi } from "@/ api/ProjectApi";
import type { StageBusinessLogic } from "@/models/interfaces/project/project-models";
import type { CommonEntity } from "@/models/interfaces/common";

type SectionKey = keyof typeof visibility;


export default /*@__PURE__*/_defineComponent({
  __name: 'StageBusinessLogicModal',
  setup(__props, { expose: __expose }) {

const $modal = ref<typeof BaseModal | null>(null);
const isLoading = ref(false);
const logic = ref<StageBusinessLogic | null>(null);

const visibility = reactive({
	settersTo: false,
	settersFrom: false,
	target: false,
	source: false,
});

const sections = computed<{ key: SectionKey; title: string; items: CommonEntity[] }[]>(() => {
	if (!logic.value) return [];

	return [
		{ key: "settersTo", title: "Сотрудники, устанавливающие этап", items: logic.value.SettersToStage },
		{ key: "settersFrom", title: "Сотрудники, снимающие этап", items: logic.value.SettersFromStage },
		{ key: "target", title: "Следующие этапы", items: logic.value.TargetStages },
		{ key: "source", title: "Предыдущие этапы", items: logic.value.SourceStages },
	];
});

const onOpen = async (stageId: number) => {
	try {
		isLoading.value = true;
		logic.value = null;
		$modal.value?.onOpen();
		logic.value = await ProjectApi.getStageBusinessLogic(stageId);
	} catch (e) {
		console.error(e);
	} finally {
		isLoading.value = false;
	}
};

__expose({ onOpen });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    loading: isLoading.value,
    title: "Бизнес-логика этапа",
    width: "600px",
    height: "600px"
  }, {
    default: _withCtx(() => [
      (!isLoading.value && logic.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (section) => {
              return (_openBlock(), _createElementBlock("section", {
                key: section.key,
                class: "stage-logic__section"
              }, [
                _createElementVNode("div", {
                  class: "stage-logic__section-title",
                  onClick: ($event: any) => (visibility[section.key] = !visibility[section.key])
                }, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(section.title), 1)
                ], 8, _hoisted_2),
                (visibility[section.key])
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (section.items?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `${section.key}-${item.Id}`,
                                class: "stage-logic__section-item"
                              }, _toDisplayString(item.Name), 1))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, "—"))
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})